export enum IdentificationType {
	IdCard = 'IdCard',
	Passport = 'Passport',
	ResidencePermit = 'ResidencePermit',
	Default = 'defaultOptionValue',
}